module.exports = __webpack_public_path__ + "e3b753fc24f50a1ff03f6b7d2a4e4318.png";